// QR Kiosk v2 — §8.5 settled progress chip for [Step: …] marker lines. Kiosk-
// calibrated (more present than desktop's quiet gray StepRowV3 — legibility). The
// label is PLAIN TEXT ONLY, never markdown/chip-processed (pinned grammar contract,
// markerBlocksV3.ts). The `live` variant (last block while streaming) appends a
// reduced-motion-safe pulsing ellipsis (.kv2-step-live). No spinner. Tokens + glyphs.
import React from "react";
import { Glyph, GD } from "../shared/glyphs";

export function MidasStepChip({ label, live }: { label: string; live?: boolean }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: 8,
        margin: "10px 0 6px",
        padding: "7px 12px",
        borderRadius: 12,
        background: "var(--bg-soft)",
        border: "1px solid var(--border-soft)",
        width: "fit-content",
        maxWidth: "100%",
      }}
    >
      <span
        style={{
          width: 20,
          height: 20,
          borderRadius: 999,
          background: "var(--midas-soft)",
          color: "var(--midas)",
          display: "grid",
          placeItems: "center",
          flexShrink: 0,
          marginTop: 1,
        }}
      >
        <Glyph d={GD.check} size={13} />
      </span>
      <span
        style={{
          fontSize: 12.5,
          fontWeight: 600,
          color: "var(--ink-2)",
          lineHeight: 1.45,
          minWidth: 0,
          wordBreak: "break-word",
        }}
      >
        {label}
        {live && (
          <span className="kv2-step-live mono" style={{ marginLeft: 4 }}>
            …
          </span>
        )}
      </span>
    </div>
  );
}

export default MidasStepChip;
